import { makeVar } from '@apollo/client';

interface CheckedOnboardingPinnedPost {
  classroomIds: string[];
}

const CHECKED_ONBOARDING_PINNED_POST_KEY = 'CHECKED_ONBOARDING_PINNED_POST';

const initialCheckedOnboardingPinnedPostMapVar =
  JSON.parse(
    window.localStorage.getItem(CHECKED_ONBOARDING_PINNED_POST_KEY) ?? '{}'
  ) || {};

export const CheckedOnboardingPinnedPostMapVar = makeVar<
  Record<string, CheckedOnboardingPinnedPost>
>(initialCheckedOnboardingPinnedPostMapVar);

export const updateCheckedOnboardingPinnedPost = (
  userId: string,
  classroomId: string
) => {
  const current = CheckedOnboardingPinnedPostMapVar();
  const updated = {
    ...current,
    [userId]: {
      classroomIds: [...(current?.[userId]?.classroomIds ?? ''), classroomId],
    },
  };

  window.localStorage.setItem(
    CHECKED_ONBOARDING_PINNED_POST_KEY,
    JSON.stringify(updated)
  );

  CheckedOnboardingPinnedPostMapVar(updated);
};
